/* eslint-disable react-refresh/only-export-components */
import Modal from '@/common/Modal';

export interface IPhotoDebugError {
  action: string;
  message: string;
  details: string;
}

const getErrorDetails = (error: unknown) => {
  if (error instanceof Error) {
    return error.stack || error.message;
  }

  try {
    return JSON.stringify(error, null, 2);
  } catch {
    return String(error);
  }
};

export const createPhotoDebugError = (action: string, error: unknown): IPhotoDebugError => {
  return {
    action,
    message: error instanceof Error ? error.message : String(error),
    details: getErrorDetails(error),
  };
};

interface IPhotoDebugErrorModalProps {
  error?: IPhotoDebugError;
  onClose: () => void;
}

function PhotoDebugErrorModal({ error, onClose }: IPhotoDebugErrorModalProps) {
  if (!error) return null;

  return (
    <Modal
      isOpen={Boolean(error)}
      onClose={onClose}
      footer={
        <button type="button" onClick={onClose}>
          Close
        </button>
      }
    >
      <h3>Image Debug Error</h3>
      <p>{error.action}</p>
      <p>{error.message}</p>
      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px' }}>{error.details}</pre>
    </Modal>
  );
}

export default PhotoDebugErrorModal;
